<div class="btn-toolbar">
  <div class="btn-group">
    <button class="btn btn-primary" [disabled]="!isValid" (click)="showDistributionsEffectedByItinerarySteps()">Save</button>
  </div>
  <div class="btn-group">
    <button class="btn btn-secondary" (click)="cancel()">Cancel</button>
  </div>
</div>
<hr />
<div class="row">
  <div class="col-md-4 content-with-scroll">
    <div class="row">
      <div class="col-md-8">
        <h1>Itinerary</h1>
      </div>
      <div class="col-md-4">
        <button class="btn btn-link pull-right" (click)="showItineraryStepShop = true">
          <h2>
            <ep-svg-icon icon="plus"></ep-svg-icon>
          </h2>
        </button>
      </div>
    </div>
    <dx-list [dataSource]="chosenSteps" [repaintChangesOnly]="true" selectionMode="single"
      [showSelectionControls]="false" [selectedItems]="selectedConfigSteps"
      (onItemClick)="stepConfigSelected($event)">
      <dxo-item-dragging group="steps" [data]="chosenSteps" [allowReordering]="true" [onReorder]="onReorder">
      </dxo-item-dragging>

      <div *dxTemplate="let stepConfig of 'item'">
        <div>
          <div class="row">
            <div class="col-md-10">
              <h2>{{ stepConfig?.step.Name }}</h2>
            </div>
            <div class="col-md-2">
              <button class="btn btn-link pull-right" (click)="removeStep(stepConfig)">Remove</button>
            </div>
          </div>
          <p>{{ stepConfig?.configStep.Description }}</p>
          @if (!stepConfig.formGroup.valid) {
            <p class="error">
              <small>Some settings needs attention</small>
            </p>
          }
        </div>
      </div>
    </dx-list>
  </div>
  <div class="col-md-8 border-left content-with-scroll">
    <div [hidden]="showItineraryStepShop">
      @for (step of chosenSteps; track step) {
        <div
          [hidden]="!selectedConfigSteps || step?.uniqueId !== selectedConfigSteps[0]?.uniqueId">
          <h1>{{ step.step.Name }}</h1>
          <div class="form-group">
            <label>Description</label>
            <textarea rows="3" [(ngModel)]="step.configStep.Description" class="form-control"></textarea>
          </div>
          <div class="justify-item">
            <div class="controls">
              <label class="control control-checkbox">
                <input type="checkbox" [(ngModel)]="step.configStep.ConfigureOnDistribution"
                  (change)="onConfigureOnDistributionChange(step)" /><i></i>
                  Configure on distribution
                </label>
                <label class="control control-checkbox">
                  <input type="checkbox" [(ngModel)]="step.configStep.OptionalOnDistribution"
                    (change)="onOptionalOnDistributionChange(step)" /><i></i>
                    Step is <span class="quote">Optional</span>
                  </label>
                  <label class="control control-checkbox margin-left">
                    <input type="checkbox" [(ngModel)]="step.configStep.DefaultActiveOnDistribution"
                      [disabled]="!step.configStep.OptionalOnDistribution" /><i></i>
                      Step is <span class="quote">Enabled</span> by default
                    </label>
                  </div>
                </div>
                @if (!step.configStep.ConfigureOnDistribution) {
                  <ep-datafield-group-container #groupContainer [numberOfColumns]="2" [datafieldGroups]="step.groups"
                  [isAlwaysEditable]="true" [formValidationGroup]="step.formGroup"></ep-datafield-group-container>
                }
              </div>
            }
          </div>
          <div [hidden]="!showItineraryStepShop">
            <div class="row">
              <div class="col-md-10">
                <h1>Available itinerary steps</h1>
              </div>
              <div class="col-md-2">
                <button class="btn btn-link pull-right" (click)="showItineraryStepShop = false">Close</button>
              </div>
            </div>
            <dx-list [dataSource]="availableSteps" [repaintChangesOnly]="true" [searchEnabled]="true" searchExpr="Name"
              selectionMode="single" searchMode="contains">

              <div *dxTemplate="let step of 'item'">
                <div>
                  <div class="row">
                    <div class="col-md-10">
                      <h2>{{ step?.Name }}</h2>
                    </div>
                    <div class="col-md-2">
                      <button class="btn btn-link pull-right" (click)="addStep(step)">
                        Add
                      </button>
                    </div>
                  </div>
                  <p>{{ step?.Description }}</p>
                </div>
              </div>
            </dx-list>
          </div>
        </div>
      </div>

      <ng-template #viewDistributionsEffectedByItineraryStepsTemplate let-c="close" let-d="dismiss">
        <div class="modal-header">
          <button type="button" class="close" aria-label="Close" (click)="d()">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">Distributions effected by itinerary step changes</h4>
        </div>
        <div class="modal-body">
          <div class="bigger">
            <label class="label label-warning">Warning: Some itinerary steps have been changed from optional to required. This update will impact the following distributions.</label>
          </div>
          <dx-data-grid biz-grid
            [dataSource]="distributionsEffectedByItinerarySteps"
            [bizHideSelectedRowsComponent]="true"
            [selection]='{ mode: "none" }'
            [columnAutoWidth]="true">
            <dxi-column dataField="DocumentConfigIn.DistributionObject.Name" caption="Document Type" dataType="string"></dxi-column>
            <dxi-column dataField="PartnerIn.PartnerName" caption="From Partner" dataType="string"></dxi-column>
            <dxi-column dataField="ConcatenatedFormatVariantVersionFrom" caption="From format/variant/version" dataType="string"></dxi-column>
            <dxi-column dataField="PartnerOut.PartnerName" caption="To Partner" dataType="string"></dxi-column>
            <dxi-column dataField="ConcatenatedFormatVariantVersionTo" caption="To format/variant/version" dataType="string" ></dxi-column>
            <dxi-column dataField="TransportConfigurationOut.Name" caption="To Configuration" dataType="string"></dxi-column>
          </dx-data-grid>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" [disabled]="!isValid" (click)="c()">Save</button>
          <button type="button" class="btn btn-secondary" (click)="d()">Close</button>
        </div>
      </ng-template>

      <ng-template #viewDistributionsBlockingChangeTemplate let-c="close" let-d="dismiss">
        <div class="modal-header">
          <button type="button" class="close" aria-label="Close" (click)="d()">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">Distributions blocking change</h4>
        </div>
        <div class="modal-body">
          <div class="bigger">
            <label class="label label-warning">These distributions would break with this change. This save can't be completed.</label>
          </div>
          <dx-data-grid biz-grid
            [dataSource]="distributionsBlockingChange"
            [bizHideSelectedRowsComponent]="true"
            [selection]='{ mode: "none" }'
            [columnAutoWidth]="true">
            <dxi-column dataField="DocumentConfigIn.DistributionObject.Name" caption="Document Type" dataType="string"></dxi-column>
            <dxi-column dataField="PartnerIn.PartnerName" caption="From Partner" dataType="string"></dxi-column>
            <dxi-column dataField="ConcatenatedFormatVariantVersionFrom" caption="From format/variant/version" dataType="string"></dxi-column>
            <dxi-column dataField="PartnerOut.PartnerName" caption="To Partner" dataType="string"></dxi-column>
            <dxi-column dataField="ConcatenatedFormatVariantVersionTo" caption="To format/variant/version" dataType="string" ></dxi-column>
            <dxi-column dataField="TransportConfigurationOut.Name" caption="To Configuration" dataType="string"></dxi-column>
          </dx-data-grid>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="d()">Close</button>
        </div>
      </ng-template>
